import React from "react";
import "./CheckoutPaymentFooter.css";
import {
  SecureCheckoutIcons,
  SecureCheckoutIconsMobile,
} from "../../../../Assets/svgs";

const CheckoutPaymentFooter = () => {
  return (
    <div className="payment-footer">
      <img
        src={SecureCheckoutIcons}
        className="secure-checkout-icons"
        alt="Secure Checkout Icons"
      />
      <img
        src={SecureCheckoutIconsMobile}
        className="secure-checkout-icons-mobile"
        alt="Secure Checkout Icons Mobile"
      />
    </div>
  );
};

export default CheckoutPaymentFooter;
